const theme = {
  colors: {
    primary: "#152128",
    secondary: "#293942",
    white: "#F9F8FF",
    purple: "#7971E9",
    gray: "rgba(249, 248, 255, 0.5)",
    lightGray: "rgba(249, 248, 255, 0.25)",
  },
};

export default theme;
